import { IResponseState } from "../../../components/Modals/ResponseModal/module/constants";
import { APPROVAL_TAB } from "../ApprovalsRequestList/module/constants";
import {
  APPROVAL_MAIN_CALL_STATE,
  SELECTED_APPROVAL_IDENTIFIER,
  ORIGINAL_APPROVAL_LIST_IDENTIFIER,
  APPROVAL_DETAIL_IDENTIFIER,
  TAB_SELECTED_IDENTIFIER,
  ATTACHMENT_CALL_STATE_IDENTIFIER,
  ATTACHMENT_CALL_STATE_IDENTIFIER_SAVE,
  APPROVALS_IDENTIFIER,
  APPROVALS_LOADER_IDENTIFIER,
  APPROVALS_CSV_DISABLED,
  APPROVALS_CSV_DATA,
} from "./constants";

const identifierApprovals = {
  [APPROVALS_IDENTIFIER]: null,
  [APPROVALS_LOADER_IDENTIFIER]: false,
  [APPROVALS_CSV_DATA]: [],
  [APPROVALS_CSV_DISABLED]: false,
  [SELECTED_APPROVAL_IDENTIFIER]: null,
  [APPROVAL_MAIN_CALL_STATE]: IResponseState.PENDING,
  [ORIGINAL_APPROVAL_LIST_IDENTIFIER]: [],
  [APPROVAL_DETAIL_IDENTIFIER]: null,
  [TAB_SELECTED_IDENTIFIER]: APPROVAL_TAB,
  [ATTACHMENT_CALL_STATE_IDENTIFIER]: IResponseState.PENDING,
  [ATTACHMENT_CALL_STATE_IDENTIFIER_SAVE]: IResponseState.PENDING,
};

export default identifierApprovals;
